export class ActionListRequest{
    public LocationID:number = -1;
    public AuditID:number = -1;
    public AuditorUserID:number = -1;
    public AuditTypeID:number = -1;
    public AuditFrequencyID:number = -1;
    public ActionTypeID:number = 1;
    public StartDate:Date;
    public EndDate:Date;
    public IncludeResolved:boolean = false;
    public OverdueOnly:boolean = false;
    public DashboardRequest:boolean = false;
    public IncludeSublocations:boolean = false;
    public PageNumber:number = 1;
    public PageSize:number = 0;
    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}
